import React from "react";
import { Row, Col, Space, Image, Typography } from "antd";
import CustomButton from "../../../components/CustomButton/Button";
import MoneyPlantHand from "../../../assets/images/money-plant-hand.png"
import { useLocation, useNavigate } from "react-router-dom";
import { formatToLacCr, formatDateLong, formatCurrency } from "../../../helpers/helpers";

const { Text } = Typography;

const OrderSummary = () => {

  const navigate = useNavigate();
  const location = useLocation()
  const { dealInfo } = location.state
  const isJointVenturesDeal = Boolean(dealInfo?.isJointVenturesDeal);

  return (
    <div className="order-summary-container">
      <div className="stepper-container">
        <CustomButton
          type="primary"
          shape="round"
          className="order-summary-btn"
        >
          1. Order Summary
        </CustomButton>

        <div className="stepper-line" />

        <CustomButton
          type="default"
          style={{ color: "#58728D" }}
          shape="round"
          className="order-summary-btn"
        >
          2. Sign Agreement
        </CustomButton>
      </div>
      <div className="order-summary">
        <div className="order-summary-header">
          <Image src={MoneyPlantHand} preview={false} alt="Money Plant" />
          <div className="header-details">
            <Typography className="returns-text">{`Awesome! Your return from this deal is ${formatCurrency(dealInfo?.expectedNetYield)} /-`} </Typography>
            <div className="header-sub-details">
              <Text className="sub-detail"><Text className="sub-detail" strong>Deal ID: </Text>{dealInfo?.dealId}</Text>
              <Text className="sub-detail"><Text className="sub-detail" strong>Enterprise Name: </Text>{dealInfo?.entName}</Text>
            </div>
          </div>
        </div>
        <Row gutter={[16, 16]} className="order-summary-details">
          <Col xs={12} md={8} lg={6}>
            <Space direction='vertical'>
              <Typography style={{ fontSize: 12, color: "#40566D" }}>Deal Value</Typography>
              <Typography style={{ fontWeight: 600, color: "#101924" }}>{formatToLacCr(Number(dealInfo?.dealValue))}</Typography>
            </Space>
          </Col>
          <Col xs={12} md={8} lg={6}>
            <Space direction='vertical'>
              <Typography style={{ fontSize: 12, color: "#40566D" }}>Maturity Date</Typography>
              <Typography style={{ fontWeight: 600, color: "#101924" }}>{formatDateLong(dealInfo?.repaymentOn)}</Typography>
            </Space>
          </Col>
          <Col xs={12} md={8} lg={6}>
            <Space direction='vertical'>
              <Typography style={{ fontSize: 12, color: "#40566D" }}>Maturity</Typography>
              <Typography style={{ fontWeight: 600, color: "#101924" }}>{dealInfo?.maturity} days</Typography>
            </Space>
          </Col>
          <Col xs={12} md={8} lg={6}>
            <Space direction='vertical'>
              <Typography style={{ fontSize: 12, color: "#40566D" }}>Expected Margin</Typography>
              <Typography style={{ fontWeight: 600, color: "#101924" }}>{formatCurrency(dealInfo?.expectedGrossProfit)}</Typography>
            </Space>
          </Col>
          {!isJointVenturesDeal ? (
            <Col xs={12} md={8} lg={6}>
              <Space direction='vertical'>
                <Typography style={{ fontSize: 12, color: "#40566D" }}>Platform Fee</Typography>
                <Typography style={{ fontWeight: 600, color: "#101924" }}>{formatCurrency(dealInfo?.platformFee)}</Typography>
              </Space>
            </Col>
          ) : null}
          {!isJointVenturesDeal ? (
            <Col xs={12} md={8} lg={6}>
              <Space direction='vertical'>
                <Typography style={{ fontSize: 12, color: "#40566D" }}>Expected Net Margin</Typography>
                <Typography style={{ fontWeight: 600, color: "#101924" }}>{formatCurrency(dealInfo?.expectedNetYield)}</Typography>
              </Space>
            </Col>
          ) : null}
          <Col xs={12} md={8} lg={6}>
            <Space direction='vertical'>
              <Typography style={{ fontSize: 12, color: "#40566D" }}>Total Payout</Typography>
              <Typography style={{ fontWeight: 600, color: "#101924" }}>{formatCurrency(dealInfo?.expectedNetRepayment)}</Typography>
            </Space>
          </Col>
          <Col xs={12} md={8} lg={6}>
            <Space direction='vertical'>
              <Typography style={{ fontSize: 12, color: "#40566D" }}>Amount to pay now</Typography>
              <Typography style={{ fontWeight: 600, color: "#101924" }}>{formatCurrency(dealInfo?.amountToPayNow)}</Typography>
            </Space>
          </Col>
        </Row>
      </div>
      <div className="order-summary-action-container">
        <CustomButton
          type="primary"
          style={{ backgroundColor: "#E3EAF3", color: "#000" }}
          className="order-summary-action-btn"
          onClick={() => navigate(-1)}
        >
          Back
        </CustomButton>
        <CustomButton
          type="primary"
          style={{ backgroundColor: "#00874F" }}
          className="order-summary-action-btn"
          onClick={() =>
            navigate("/agreement", { replace: true, state: { dealInfo } })
          }
        >
          Next
        </CustomButton>
      </div>
    </div>
  );
};

export default OrderSummary;
